// extracted by mini-css-extract-plugin
export default {"rootLgForm":"Language_rootLgForm__n3sAc","formItem":"Language_formItem__tnHIV","selectLanguage":"Language_selectLanguage__RP8r5","confirm":"Language_confirm__Icy2O"};